module.exports = __webpack_public_path__ + "img/net.586f26d8.svg";